import Vue from 'vue'
import Vuex from 'vuex'
import userMod from './user'
import apiMenu from './apiMenu'
import country from './country'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user: userMod,
    apiMenu,
    country
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js